const presentHost = window.location.host

// 前端
export const mHost = presentHost
// 后端
export const zzHost =
  presentHost === 'm2.zhuanzhuan.58.com' ? 'https://zhuan.58.com' : 'https://app.zhuanzhuan.com'

// 前端阿波罗
export const feHost = 'https://feconf.zhuanzhuan.com/feconf/zhuanzhuanfe.recycle'
// 门店回收
export const feStoreHost = 'https://feconf.zhuanzhuan.com/feconf/zhuanzhuanfe.store'
